export enum ELocalisationQualifSalle {
    BlocOperatoire = 1,
    Sterilisation,
    Pharmacie,
    UniteDeSoinsIntensifs,
    Autre,
    UniteDePreparationDeMedicament
}